import request from '@/axios/index.js'

// 保存、更新开立复核权限
export function ruleSaveOrUpdate(data,loading) {
    return request.axios({
        loading:loading,
        data:data,
        url:'/role/ruleSaveOrUpdate'
    })
}
// 查询开立复核权限规则
export function queryRule(data,loading) {
  return request.axios({
      loading:loading,
      data:data,
      url:'/role/queryRule'
  })
}
// 多级复核角色用户绑定查询
export function queryUserRel(data,loading) {
  return request.axios({
      loading:loading,
      data:data,
      url:'/role/queryUserRel'
  })
}
// 判断是否核心企业
export function isCoreCst(data) {
  return request.axios({
      data:data,
      type:"get",
      url: '/cst/isCoreCst'
  })
}




// WEBPACK FOOTER //
// ./src/api/issueReview.js